import { useCallback } from 'react'

import { UseHandleDateTimePickerChange } from '../interfaces'

export const useHandlePickupChange: UseHandleDateTimePickerChange = ({ values, setValues, setTouched, touched }) => {
  return useCallback(
    ({ day, month, year, time }) => {
      const updatedDate = new Date(year, month, day, Number(time))
      if (values.startDate?.getTime() === updatedDate.getTime() && values.pickupAt === time) {
        return
      }

      setValues((prevValues) => ({
        ...prevValues,
        startDate: updatedDate,
        pickupAt: time,
        endDate: null,
        returnAt: null,
      }))
      setTouched({ ...touched, startDate: true, endDate: true })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [values.startDate, values.pickupAt, values.endDate, values.returnAt, setValues, setTouched],
  )
}
